import { render } from "./ReportError.vue?vue&type=template&id=32b37c15&scoped=true"
import script from "./ReportError.vue?vue&type=script&lang=js"
export * from "./ReportError.vue?vue&type=script&lang=js"

import "./ReportError.vue?vue&type=style&index=0&id=32b37c15&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32b37c15"]])

export default __exports__